import { useMemo } from "react";

import { cn } from "@/lib/utils";

interface TabContentProps {
  solidIcon?: React.ReactNode;
  outlineIcon?: React.ReactNode;
  name: string;
  isActive: boolean;
  isRightAligned?: boolean;
  count?: number;
}

export const TabContent = ({
  solidIcon,
  outlineIcon,
  name,
  isActive,
  isRightAligned = false,
  count,
}: TabContentProps) => {
  const solidIconClass = useMemo(() => {
    const baseClass = "absolute inset-0 transition-opacity duration-300";
    const colorClass = isRightAligned ? "text-blue-300" : "text-blue-400";
    const visibilityClass = isActive ? "opacity-100" : "opacity-0";
    return `${baseClass} ${colorClass} ${visibilityClass}`;
  }, [isRightAligned, isActive]);

  const outlineIconClass = useMemo(() => {
    const baseClass = "absolute inset-0 transition-opacity duration-300";
    const colorClass = isRightAligned ? "text-gray-300" : "text-gray-400";
    const visibilityClass = isActive ? "opacity-0" : "opacity-100";
    return `${baseClass} ${colorClass} ${visibilityClass}`;
  }, [isRightAligned, isActive]);

  return (
    <span className="flex items-center">
      {(solidIcon || outlineIcon) && (
        <span className="relative mr-2 h-4 w-4">
          <span className={solidIconClass}>{solidIcon}</span>
          <span className={outlineIconClass}>{outlineIcon}</span>
        </span>
      )}
      {name && name}
      {count !== undefined && count > 0 && (
        <span
          className={cn(
            "ml-1.5 inline-flex h-5 min-w-5 items-center justify-center rounded-full px-1.5 text-xs font-medium",
            isActive ? "bg-blue-400 text-white" : "bg-blue-100 text-blue-700",
          )}
        >
          {count}
        </span>
      )}
    </span>
  );
};
